import { HttpErrorResponse } from '@angular/common/http';

/**
 * Extrae el mensaje de error enviado por el backend desde una excepción HTTP.
 * Formato habitual: `{ error: "Validation failed: ..." }`
 */
export function extractHttpErrorMessage(error: unknown): string | undefined {
  if (!error) return undefined;

  let payload: unknown = error;
  if (error instanceof HttpErrorResponse) {
    payload = error.error;
  } else if (typeof error === 'object' && error !== null && 'error' in error) {
    payload = (error as { error: unknown }).error;
  }

  if (typeof payload === 'string' && payload.trim().length > 0) {
    return formatBackendErrorMessage(payload);
  }

  if (payload && typeof payload === 'object') {
    const inner = (payload as { error?: unknown }).error;
    if (typeof inner === 'string' && inner.trim().length > 0) {
      return formatBackendErrorMessage(inner);
    }
    const message = (payload as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim().length > 0) {
      return formatBackendErrorMessage(message);
    }
  }

  return undefined;
}

/** Limpia mensajes de validación tipo FluentValidation para mostrarlos en UI. */
function formatBackendErrorMessage(message: string): string {
  return message
    .replace(/^Validation failed:\s*/i, '')
    .replace(/\s*Severity:\s*Error/gi, '')
    .replace(/\r\n/g, '\n')
    .split('\n')
    .map((line) => line.replace(/^\s*--\s*/, '').trim())
    .filter(Boolean)
    .join('\n');
}
